<script>
export default {
  data: function () {
    return {
      username: '',
      display: false,
    }
  },
  methods: {
    show() {
      this.display = true
    },
    go() {
      document.location = '/switch_user.php?user=' + this.username
    },
  },
}
</script>
<template>
  <li class="topbar-li-style">
    <a class="topbar-btn">
      <i class="ti-eye" @click="show()" e2e-button="toggleSwitchUser" />
    </a>
    <input
      v-if="display"
      v-model="username"
      id="switch_user"
      name="switch_user"
      class="switch_user_input"
      type="text"
      e2e-input="switchUser"
    />
    <i v-if="display" @click="go()" class="ti-user" style="padding-left: 10px" e2e-button="switchUser" />
  </li>
</template>
